import ContactInformationPage from './ContactInformation.page';

export default ContactInformationPage;
